'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exam = function (_React$PureComponent) {
  _inherits(Exam, _React$PureComponent);

  function Exam() {
    _classCallCheck(this, Exam);

    return _possibleConstructorReturn(this, (Exam.__proto__ || Object.getPrototypeOf(Exam)).apply(this, arguments));
  }

  _createClass(Exam, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          width: this.props.size,
          height: this.props.size,
          viewBox: '0 0 114 112',
          version: '1.1',
          xmlnsXlink: 'http://www.w3.org/1999/xlink'
        },
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(-7.000000, -8.000000) translate(7.000000, 8.000000)',
            stroke: 'none',
            strokeWidth: 1,
            fill: 'none',
            fillRule: 'evenodd'
          },
          _react2.default.createElement('path', {
            d: 'M113.955 55.605v12.177c0 1.681-1.79 3.055-4.013 3.055-2.222 0-4.065-1.36-4.065-3.055V55.605c.139-1.437 1.215-2.596 2.614-2.814V35.985l-13.515 6.696v24.274c0 12.004-18.457 18.006-37.097 18.1h-.875c-18.705-.094-37.28-6.136-37.293-18.02V43.508l-18.3-8.63c-1.908-1.067-1.816-4.881.144-5.748l50.35-22.955a12.954 12.954 0 0 1 4.576-.84c1.836.006 3.65.41 5.32 1.187l50.768 21.687c1.935 1.054 1.843 4.909-.143 5.776l-.994.493v18.313c1.352.276 2.373 1.415 2.523 2.814z',
            fill: '#000',
            fillRule: 'nonzero',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M109.916 47.216c-2.222 0-4.013 1.333-4.013 3.054v12.177c0 1.68 1.804 3.041 4.026 3.041 2.222 0 4.013-1.333 4.013-3.054V50.257c0-1.68-1.804-3.041-4.026-3.041z',
            fill: '#4978BB'
          }),
          _react2.default.createElement('path', {
            d: 'M19.685 32.97v28.69c0 11.884 18.6 17.926 37.292 18.02h.876c18.64-.094 37.11-6.096 37.096-18.1V32.89l-75.264.08zm88.715-4.32v19.86a1.392 1.392 0 0 0 1.516 1.226 1.392 1.392 0 0 0 1.503-1.227V28.65h-3.02z',
            fill: '#265D9E'
          }),
          _react2.default.createElement('path', {
            d: 'M51.906.84L1.529 23.755c-1.96.88-2.065 4.681-.143 5.761l50.52 23.835a12.652 12.652 0 0 0 9.895.467l50.612-25.169c1.986-.866 2.09-4.721.143-5.775L61.801 1.2A12.66 12.66 0 0 0 56.468 0c-1.557.005-3.102.29-4.562.84z',
            fill: '#4978BB'
          }),
          _react2.default.createElement('path', {
            d: 'M30.064 88.416c1.02.64.771.507 1.764 1.067l12.013 6.815c2.222 1.268-9.555-2.667-11.908-3.627l-5.908-3.308S11.92 79.72 7.307 76.945c-.771-.44 1.385-4.321 1.843-5.055.444-.746 2.902-4.548 3.66-4.12 7.176 4 11.764 6.668 20.326 11.523.585.316 1.126.71 1.607 1.174l-4.68 7.949z',
            fill: '#008370'
          }),
          _react2.default.createElement('path', {
            d: 'M71.892 110.877l3.02-5.135c.158-.268.204-.59.125-.892a1.144 1.144 0 0 0-.544-.709l-40.246-22.86-4.183 7.175 40.272 22.86a1.202 1.202 0 0 0 1.556-.44',
            fill: '#00BE9C'
          }),
          _react2.default.createElement('path', {
            d: 'M71.892 110.877l.523-.88c.159-.268.204-.59.125-.892a1.144 1.144 0 0 0-.544-.71L31.75 85.536l-1.686 2.92 40.272 22.862a1.202 1.202 0 0 0 1.556-.44',
            fill: '#231F20',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M34.247 81.28l-4.183 7.123c1.02.64.771.506 1.764 1.067l12.013 6.815c2.222 1.267-9.555-2.667-11.908-3.628l-5.908-3.294s-9.843-6.91-18.718-12.39c-.771-.468 1.385-4.349 1.843-5.083 2.313 3.708 16.156 21.047 25.084 9.444',
            fill: '#231F20',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M82.349 78.626l4.392 8.19c-.994.68-.758.533-1.726 1.133l-11.764 7.282c-2.183 1.334 7.843-1.88 10.104-2.96l5.778-3.562s12.404-6.669 18.012-17.005c.44-.705.5-1.589.157-2.348a1.922 1.922 0 0 0-2.079-1.013c-7.28 1.427-12.953 4-21.293 9.15-.578.34-1.11.757-1.581 1.24',
            fill: '#008370'
          }),
          _react2.default.createElement('path', {
            d: 'M45.75 110.877l-2.876-5.269a1.268 1.268 0 0 1 .431-1.654L82.78 79.506l3.921 7.35-39.435 24.447c-.257.15-.56.188-.845.108a1.115 1.115 0 0 1-.672-.534',
            fill: '#00BE9C'
          }),
          _react2.default.createElement('path', {
            d: 'M45.75 110.877l-.484-.907a1.268 1.268 0 0 1 .431-1.654l39.475-24.448 1.608 2.987-39.514 24.448c-.257.15-.56.188-.845.108a1.115 1.115 0 0 1-.672-.534',
            fill: '#231F20',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M82.78 79.506l3.921 7.296c-.993.68-.758.534-1.725 1.134l-11.764 7.282c-2.183 1.334 7.843-1.88 10.104-2.96l5.777-3.562s12.405-6.669 18.013-17.006a2.497 2.497 0 0 0 .196-2.334c-2.314 3.882-16.052 22.1-24.483 10.27',
            fill: '#231F20',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M74.689 12.39c-.175 0-.349-.036-.51-.106L57.84 5.335a1.37 1.37 0 0 1-.334-2.324c.372-.3.873-.375 1.315-.197L75.199 9.83c.57.248.892.872.768 1.492a1.314 1.314 0 0 1-1.278 1.069zm31.554 13.525c-.175 0-.349-.036-.51-.106l-26.09-11.137a1.345 1.345 0 0 1-.647-1.728c.274-.66 1.01-.98 1.667-.727l26.142 11.19c.571.249.892.873.769 1.493a1.314 1.314 0 0 1-1.279 1.069l-.052-.054z',
            fill: '#FFF',
            fillRule: 'nonzero',
            opacity: '0.3'
          })
        )
      );
    }
  }]);

  return Exam;
}(_react2.default.PureComponent);

Exam.defaultProps = {
  size: '24'
};

Exam.propTypes = {
  size: _propTypes2.default.number
};

exports.default = Exam;